import Vue from 'vue';
import App from './App.vue';
import router from '@/router/index';
import store from '@/store/index';
import debounce from './plugins/vue-debounce';
import './plugins/base';
import VueTheMask from 'vue-the-mask'; 

// import './plugins/chartist' -- charts plugin
// import './plugins/vee-validate' -- forms validator
// import './plugins/vue-world-map' -- A Vue JS component for displaying a world map with colored countries and overlay information
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;
Vue.use(VueTheMask);

const irisApp = new Vue({
	store,
	router,
	vuetify,
	debounce,
	render: (h) => h(App),
});
irisApp.$mount('#app');
